import { useState, useEffect } from 'react';
import { Row, Col, Accordion, Card } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Avatar } from '@material-ui/core';
import { toast } from 'react-toastify';
import ToastMessage from '../../../common/ToastMessage';
import CustomClientError from '../../../../errorhandling/CustomClientError';
import useDate from '../../../../utils/useDate';
import UserDefinedLabels from '../../../../utils/UserDefinedLabels';
import { maskedOther, maskedSSN } from '../../../../../common/masking';
import { HttpSuccessCodes } from 'src/Admin/errorhandling/HttpErrorCodes';
import {
  AccordionDownArrow,
  AccordionUpArrow,
  PlusSVG,
  EditIcon,
  EnrollMinusIcon,
} from '../EnrollmentIconsSvg';
import Skeleton from './skeleton/DependentInfoSkeleton';
import APIEndpoints from '../../../../api/APIEndpoints';
import { axiosInstance } from '../../../../../api/axios';
import {
  getViewEmployeeDetails,
  getViewContactInformation,
  formatDependentName,
} from '../../../../utils/common';
import { setMemberDetails } from '../../../../../redux/admin/memberModule';
import EditDependentInfo from './EditDependentInfo';
import AddDependentInfo from './AddDependentInfo';
import GenericMessage from 'src/Components/GenericMessage/GenericMessage';
import MasterPermissions from '../../../../api/MasterPermissions';
import GenericButton from '../../../../../Components/GenericButton/GenericButton';
import DepSkeleton from '../../../../components/common/skeleton';

import '../../enrollment.scss';
import './styles/dependent-info.scss';

const DependentInfo = ({
  nextStep,
  prevStep,
  //setAddDepenedentInfoStep,
  enrollmentFormData,
  setEnrollmentFormData,
}) => {
  console.log('enrollmentFormData DependentInfo', enrollmentFormData);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [activeId, setActiveId] = useState(null);
  const [dependentsData, setDependentsData] = useState([]);
  const [depResidenceAddress, setDepResidenceAddress] = useState(null);
  const [depMailingAddress, setDepMailingAddress] = useState(null);
  const [activeDependentId, setactiveDependentId] = useState('');
  const [activeDependentSequenceId, setActiveDependentSequenceId] =
    useState('');

  //const [dependentsInfoLoaded, setDependentsInfoLoaded] = useState(false);

  const [
    showEditDependentsContactDetails,
    setShowEditDependentsContactDetails,
  ] = useState(false);

  const [showAddDependents, setShowAddDependents] = useState(false);

  const [editDependentsContactItem, setEditDependentsContactItem] = useState({
    dependentsInformation: null,
    residenceAddress: null,
    mailingAddress: null,
    dependentDetails: null,
  });

  const noValue = 'Not Specified';
  const { Suppress_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const { selectedMember, memberDetails } = useSelector(
    (state) => state.memberModule,
  );
  const { CertificateNumberLabel, AlternateID1Label, AlternateID2Label } =
    UserDefinedLabels();
  const { formatDate } = useDate();
  const userSelectedEnrollmentFlow = enrollmentFormData.selectedEnrollmentFlow;
  //const {
  //familyMember = {},
  //dependentsInfo,
  //viewMember,
  //} = useSelector((state) => state.memberSummary || {});
  const dependentsInfo = enrollmentFormData.dependentsInformation;

  let { themeValuesObject } = useSelector((state) =>
    state?.theme?.branding
      ? state?.theme?.branding
      : { themeValuesObject: { 'Secondary-1': '#1D90BA' } },
  );
  if (!themeValuesObject) {
    themeValuesObject = { 'Secondary-1': '#1D90BA' };
  }
  console.log('dependentsInfo >>>>>>> >>>>>>>>>>>> ', dependentsInfo);

  const toggleActive = async (
    id,
    dependentsInfoLoaded,
    dependentsAPIError,
    isNewlyAdd,
    itemDetails,
  ) => {
    //setDependentsInfoLoaded(true);
    if (
      !dependentsInfoLoaded ||
      id === enrollmentFormData.updatedCurrentDependentNumber ||
      id !== activeDependentSequenceId ||
      (dependentsInfoLoaded && dependentsAPIError)
    ) {
      if (!isNewlyAdd && !itemDetails?.isDependentUpdated) {
        fetchDependentsData(id);
      } else {
        if (itemDetails?.isDependentUpdated) {
          setDepResidenceAddress(itemDetails.DependentResidentailAddress);
          setDepMailingAddress(itemDetails.DependentMailingAddress);
        }
      }
    }
    if (activeId === id) {
      setActiveId(null);
    } else {
      setActiveId(id);
    }
  };

  //const getStatusBySeq = (seq) => {
  //let status = '';
  //const item = viewMember.DependentsInfo.filter(
  //(f) => f.DepSequenceNumber == seq,
  //);
  //if (item && item.length > 0) {
  //status = item[0].Status;
  //}
  //return status;
  //};

  /*const formatDependentsData = () => {
    console.log('dependentsInfo >>>> FormatDependent >>>>>> ', dependentsInfo);
    const sequenseIDs = dependentsInfo?.reduce((acc, cur) => {
      acc.push(cur.DepSequenceNumber);
      return acc;
    }, []);
    const hipaaMembers = dependentsInfo?.filter((item) =>
      sequenseIDs.includes(item.DepSequenceNumber),
    );
    return (
      hipaaMembers.length &&
      hipaaMembers.map((item) => ({
        ...item,
        dependentsInfoLoaded: false,
        dependentsAPIError: false,
      }))
    );
  };*/

  const fetchDependentsData = async (DepSequenceNumber) => {
    try {
      const params = configureParams(DepSequenceNumber);
      const responseDependentsData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );
      const tempDependentsData = [...dependentsData].map((item) =>
        item.DepSequenceNumber === DepSequenceNumber
          ? {
              ...item,
              dependentsInfoLoaded: true,
              DependentsInformation: getViewEmployeeDetails(
                responseDependentsData?.data?.Response?.DependentsInformation,
                true,
              ),
              DependentResidentailAddress: getAddressLine(
                responseDependentsData?.data?.Response
                  ?.Dependentresidentailaddress[0],
              ),
              DependentMailingAddress: getAddressLine(
                responseDependentsData?.data?.Response
                  ?.Dependentmailingaddress[0] || undefined,
              ),
              DependentResidentailAddressZip: getAddressLineZip(
                responseDependentsData?.data?.Response
                  ?.Dependentresidentailaddress[0],
              ),
              DependentMailingAddressZip: getAddressLineZip(
                responseDependentsData?.data?.Response
                  ?.Dependentmailingaddress[0] || undefined,
              ),
              PhoneEmailInfo: getViewContactInformation(
                responseDependentsData?.data?.Response?.DependentsInformation,
                true,
              ),
            }
          : { ...item },
      );
      if (
        DepSequenceNumber === enrollmentFormData.updatedCurrentDependentNumber
      ) {
        setEnrollmentFormData({
          ...enrollmentFormData,
          updatedCurrentDependentNumber: 0,
        });
      }
      setActiveDependentSequenceId(DepSequenceNumber);
      const dependentId = params.split('/')[1];
      setactiveDependentId(dependentId);
      setDependentsData(tempDependentsData);
      const dependentresidentailaddress =
        responseDependentsData?.data?.Response?.Dependentresidentailaddress[0];

      const dependentMailingAddress =
        responseDependentsData?.data?.Response?.Dependentmailingaddress[0];

      setDepResidenceAddress(dependentresidentailaddress);
      setDepMailingAddress(dependentMailingAddress);
      //setDependentsInfoLoaded(false);
    } catch (e) {
      const tempDependentsData = [...dependentsData].map((item) =>
        item.DepSequenceNumber === DepSequenceNumber
          ? { ...item, dependentsInfoLoaded: true, dependentsAPIError: true }
          : { ...item },
      );
      setDependentsData(tempDependentsData);
    }
  };

  const getAddressLine = (address) => {
    return `${address?.Address1 ? address?.Address1 : ''} ${
      address?.Address2 ? address?.Address2 : ''
    } ${address?.Address3 ? address?.Address3 : ''} ${
      address?.County ? address?.County : ''
    } ${address?.City ? address?.City + ',' : ''} ${
      address?.State ? address?.State : ''
    }`;
  };

  const getAddressLineZip = (address) => {
    return `${address?.PostalCode ? address?.PostalCode : ''} ${
      address?.Country ? address?.Country : ''
    } `;
  };

  //const configureParams = (DepSequenceNumber) => {
  //const selectedDependent = dependentsInfo.filter(
  //(item) => item.DepSequenceNumber === parseInt(DepSequenceNumber),
  //)[0];
  //return `oid/${selectedDependent.OID}/membertype/Dependent`;
  //};
  const configureParams = (DepSequenceNumber) => {
    const dependentsList = memberDetails?.Member?.DependentsInfo;
    const selectedDependent = dependentsList.filter(
      (item) => item.MemberSeqID === parseInt(DepSequenceNumber),
    )[0];
    return `oid/${selectedDependent.OID}/membertype/Dependent`;
  };

  const addDepenedentInfo = () => {
    //setAddDepenedentInfoStep(true);
    //nextStep();
    setShowAddDependents(true);
  };

  const updateDependentsContactInfo = (
    residenceAddress,
    mailingAddress,
    depData,
    item,
  ) => {
    setShowEditDependentsContactDetails(true);
    setEditDependentsContactItem({
      dependentsInformation: depData,
      residenceAddress: residenceAddress,
      mailingAddress: mailingAddress,
      dependentDetails: item,
    });
  };

  const onContinueHandler = () => {
    nextStep();
    setEnrollmentFormData({
      ...enrollmentFormData,
      newlyAddedDependent: [],
    });
  };

  const getDependentDeatils = async (item) => {
    try {
      const params = configureParams(item.DepSequenceNumber);
      const responseDependentsData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );
      if (
        [
          HttpSuccessCodes.HTTP_SUCCESS_CODE_200,
          HttpSuccessCodes.HTTP_SUCCESS_CODE_201,
        ].includes(responseDependentsData?.status)
      ) {
        const tempDependentObj = {
          ...item,
          dependentsInfoLoaded: true,
          DependentsInformation: getViewEmployeeDetails(
            responseDependentsData?.data?.Response?.DependentsInformation,
            true,
          ),
          DependentResidentailAddress: getAddressLine(
            responseDependentsData?.data?.Response
              ?.Dependentresidentailaddress[0],
          ),
          DependentMailingAddress: getAddressLine(
            responseDependentsData?.data?.Response
              ?.Dependentmailingaddress[0] || undefined,
          ),
          DependentResidentailAddressZip: getAddressLineZip(
            responseDependentsData?.data?.Response
              ?.Dependentresidentailaddress[0],
          ),
          DependentMailingAddressZip: getAddressLineZip(
            responseDependentsData?.data?.Response
              ?.Dependentmailingaddress[0] || undefined,
          ),
          PhoneEmailInfo: getViewContactInformation(
            responseDependentsData?.data?.Response?.DependentsInformation,
            true,
          ),
        };
        const removedFromUpdatedObject =
          enrollmentFormData.updatedDependentDetails.filter((object) => {
            return object.DepSequenceNumber !== item.DepSequenceNumber;
          });
        setEnrollmentFormData({
          ...enrollmentFormData,
          removedExistingDependent: [
            ...enrollmentFormData.removedExistingDependent,
            tempDependentObj,
          ],
          newlyAddedDependent: [],
          updatedDependentDetails: removedFromUpdatedObject,
        });
      } else {
        toast.error(
          <ToastMessage
            type="error"
            subTitle="Your remove dependent request has not been submitted successfully"
          />,
        );
      }
    } catch (e) {
      console.log('Error >>>>>>>>>>>', e);
      toast.error(
        <ToastMessage
          type="error"
          subTitle="Your remove dependent request has not been submitted successfully"
        />,
      );
    }
  };

  const handleExistingDependentRemove = (item) => {
    if (item.dependentsInfoLoaded) {
      const removedDuplicateObject =
        enrollmentFormData.updatedDependentDetails.filter((object) => {
          return object.DepSequenceNumber !== item.DepSequenceNumber;
        });
      setEnrollmentFormData({
        ...enrollmentFormData,
        removedExistingDependent: [
          ...enrollmentFormData.removedExistingDependent,
          item,
        ],
        newlyAddedDependent: [],
        updatedDependentDetails: removedDuplicateObject,
      });
    } else {
      getDependentDeatils(item);
    }
  };

  const handleNewlyAddedDependentRemove = (e, item) => {
    e.stopPropagation();
    let temNewlyAddedDependent = enrollmentFormData.allNewlyAddedDependent;
    if (temNewlyAddedDependent.length > 0) {
      temNewlyAddedDependent = temNewlyAddedDependent.filter((objOne) => {
        return objOne.DepSequenceNumber !== item.DepSequenceNumber;
      });
    }
    setEnrollmentFormData({
      ...enrollmentFormData,
      allNewlyAddedDependent: temNewlyAddedDependent,
      removedExistingDependent: [
        ...enrollmentFormData.removedExistingDependent,
        item,
      ],
      newlyAddedDependent: [],
    });
  };

  const getDependentDetails = async () => {
    console.log('Dependent getDependentDetails >>>>>>>> :::: >>>>>>>>>> ');
    try {
      const params = `oid/${selectedMember.ID}/membertype/${selectedMember.mType}`;
      const responseEmployeeData = await axiosInstance.get(
        APIEndpoints.getViewMemberinformation() + params,
      );
      if (
        responseEmployeeData.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200
      ) {
        console.log(
          'Dependent getDependentDetails success >>>>>>>> :::: >>>>>>>>>> ',
          responseEmployeeData,
        );
        setEnrollmentFormData({
          ...enrollmentFormData,
          dependentsInformation:
            responseEmployeeData?.data?.Response?.DependentsInfo,
          isDependentInfoAvailable: true,
        });
      } else {
        setEnrollmentFormData({
          ...enrollmentFormData,
          isDependentInfoAvailable: true,
        });
      }
    } catch (error) {
      console.log('Error in Dependent getDependentDetails() >>>> ', error);
      setEnrollmentFormData({
        ...enrollmentFormData,
        isDependentInfoAvailable: true,
      });
    }
  };

  const getMemberDetails = async () => {
    console.log(
      'Dependent getMemberDetails >>>>>>>> :::: >>>>>>>>>> ',
      getMemberDetails,
    );
    try {
      const response = await axiosInstance.get(
        APIEndpoints.getMemberSummaryResource() +
          'membertype/' +
          selectedMember?.mType +
          '/oid/' +
          selectedMember?.ID,
      );

      const memberSummaryDataResp = response.data;
      //const memberSummary = memberSummaryDataResp?.Response?.Member;
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        dispatch(setMemberDetails(memberSummaryDataResp?.Response));
      }
    } catch (error) {
      console.log('Error in dependentInfo getMemberDetails() >>>> ', error);
    }
  };

  const handleValidation = () => {
    if (userSelectedEnrollmentFlow === 'AddDependent') {
      return !enrollmentFormData.allNewlyAddedDependent.length > 0;
    } else if (userSelectedEnrollmentFlow === 'DeleteDependent') {
      return !enrollmentFormData.removedExistingDependent.length > 0;
    } else {
      return false;
    }
  };

  useEffect(() => {
    if (!enrollmentFormData?.isDependentInfoAvailable) {
      getDependentDetails();
    }
  }, []);

  useEffect(() => {
    getMemberDetails();
  }, []);

  useEffect(() => {
    let defaultDependents = [];
    if (dependentsInfo?.length > 0) {
      //defaultDependents = formatDependentsData();
      defaultDependents = dependentsInfo;
    }
    console.log('defaultDependents ::::::>>>>>>> ::: ', defaultDependents);
    if (enrollmentFormData.removedExistingDependent.length > 0) {
      /*enrollmentFormData.removedExistingDependent.map((removeObj) => {
        defaultDependents.map((compareObj, i) => {
          if (removeObj.DepSequenceNumber === compareObj.DepSequenceNumber) {
            defaultDependents.splice(i, 1);
          }
        });
      });*/
      defaultDependents = defaultDependents.filter((objOne) => {
        return !enrollmentFormData.removedExistingDependent.some((objTwo) => {
          return objOne.DepSequenceNumber === objTwo.DepSequenceNumber;
        });
      });
    }
    setDependentsData([
      ...enrollmentFormData.allNewlyAddedDependent,
      ...defaultDependents,
    ]);
  }, [enrollmentFormData.dependentsInformation]);

  useEffect(() => {
    if (
      dependentsData.length > 0 ||
      enrollmentFormData.newlyAddedDependent.length > 0
    ) {
      let tempDependentsData = dependentsData;
      if (tempDependentsData.length > 0) {
        tempDependentsData = tempDependentsData.filter((objOne) => {
          return !enrollmentFormData.removedExistingDependent.some((objTwo) => {
            return objOne.DepSequenceNumber === objTwo.DepSequenceNumber;
          });
        });
      }
      setDependentsData([
        ...enrollmentFormData.newlyAddedDependent,
        ...tempDependentsData,
      ]);
    }
  }, [
    enrollmentFormData.newlyAddedDependent,
    enrollmentFormData.removedExistingDependent,
  ]);

  useEffect(() => {
    if (
      dependentsData.length > 0 &&
      enrollmentFormData.updatedDependentDetails.length > 0
    ) {
      console.log('dependentsData :::::: >>>  ', dependentsData);
      let tempDependentsData = dependentsData;
      if (tempDependentsData.length > 0) {
        tempDependentsData = tempDependentsData.map(
          (dep) =>
            enrollmentFormData.updatedDependentDetails.find(
              (updatedDep) =>
                updatedDep.DepSequenceNumber === dep.DepSequenceNumber,
            ) || dep,
        );
      }
      setDependentsData(tempDependentsData);
    }
  }, [enrollmentFormData.updatedDependentDetails]);

  /*useEffect(() => {
    enrollmentFormData.dependentsInfo = [];
    dependentsData &&
      dependentsData.map((d) =>
        enrollmentFormData.dependentsInfo.push(d.DepFirstName),
      );
  }, [dependentsData]);*/

  //console.log('dependentsData', dependentsData);
  return (
    <div className="dependent-info-container">
      {enrollmentFormData?.isDependentInfoAvailable &&
        !showEditDependentsContactDetails &&
        !showAddDependents && (
          <Row>
            <Col md="12">
              <div className="my-profile-member-container">
                <div
                  className="row-title-header"
                  style={{ justifyContent: 'space-between' }}
                >
                  <div>
                    <h2 className="row-title" tabIndex={0}>
                      Dependents
                    </h2>
                  </div>
                  {enrollmentFormData?.selectedEnrollmentFlow ===
                    'AddDependent' && (
                    <div>
                      <GenericButton
                        variant="secondary"
                        onClick={() => addDepenedentInfo()}
                      >
                        <span>
                          <PlusSVG className="svg-icons" />
                        </span>
                        <span className="button-space">ADD DEPENDENT</span>
                      </GenericButton>
                    </div>
                  )}
                </div>
                {dependentsData.length ? (
                  <Accordion>
                    <div className="personal-info-section">
                      {dependentsData &&
                        dependentsData.map((item, index) => (
                          <div key={index} className="mb-1 hr-sep">
                            <Accordion.Toggle
                              as={Card.Header}
                              onClick={() => {
                                setEnrollmentFormData({
                                  ...enrollmentFormData,
                                  activedependentSequenceNumber:
                                    item.DepSequenceNumber,
                                });
                                toggleActive(
                                  item.DepSequenceNumber,
                                  item.dependentsInfoLoaded,
                                  //dependentsInfoLoaded,
                                  item.dependentsAPIError,
                                  item.DependentNewlyAdded,
                                  item,
                                );
                              }}
                              className="bg-white panel-toggle border-0 py-3"
                              eventKey={item.DepSequenceNumber}
                            >
                              <div className="d-flex panel-card-header align-items-center">
                                <div className="pr-3">
                                  <span className="accordion-arrow">
                                    {activeId === item.DepSequenceNumber ? (
                                      <AccordionUpArrow className="acc-arrow" />
                                    ) : (
                                      <AccordionDownArrow className="acc-arrow" />
                                    )}
                                  </span>
                                </div>
                                {/*<div className="top-header-container-dependent border-0 w-100 p-0"> */}
                                <div
                                  className={`${
                                    userSelectedEnrollmentFlow ===
                                      'AddDependent' ||
                                    userSelectedEnrollmentFlow ===
                                      'DeleteDependent' ||
                                    userSelectedEnrollmentFlow ===
                                      'AddressChange' ||
                                    item.DependentNewlyAdded
                                      ? 'top-header-container-dependent'
                                      : 'top-header-container'
                                  } border-0 w-100 p-0`}
                                >
                                  <div className="avarat-wrapper">
                                    <Avatar className="my-profile-avatar">
                                      {item.DepFirstName &&
                                        item.DepFirstName.charAt(
                                          0,
                                        ).toUpperCase()}
                                      {item.DepLastName &&
                                        item.DepLastName.charAt(
                                          0,
                                        ).toUpperCase()}
                                    </Avatar>
                                  </div>
                                  <div className="title-age-container">
                                    <div className="my-profile-title">{`${formatDependentName(
                                      item,
                                    )}`}</div>
                                    <div className="my-profile-age">
                                      {item.RelationshipToEmployee || ''}
                                    </div>
                                    {userSelectedEnrollmentFlow ===
                                      'DeleteDependent' &&
                                      !item.DependentNewlyAdded && (
                                        <div className="my-profile-status display-for-mobile">
                                          <div>Status</div>
                                          <div className="font-weight-bold">
                                            {item.Status || noValue}
                                          </div>
                                        </div>
                                      )}
                                  </div>
                                  {userSelectedEnrollmentFlow ===
                                    'AddDependent' ||
                                  userSelectedEnrollmentFlow ===
                                    'DeleteDependent' ? (
                                    <div className="enrollment-dependent-btn-container">
                                      {item.DependentNewlyAdded ? (
                                        <div className="newly-added-btn-container">
                                          <div className="newly-added-label">
                                            Newly Added
                                          </div>
                                          {/*{MasterPermissions.CheckPermission(
                                          'Delete Dependent',
                                        ) && ( */}
                                          <div>
                                            <GenericButton
                                              variant="secondary"
                                              className="btn-remove"
                                              onClick={(e) => {
                                                handleNewlyAddedDependentRemove(
                                                  e,
                                                  item,
                                                );
                                              }}
                                            >
                                              <span>
                                                <EnrollMinusIcon className="remove-icon" />
                                              </span>
                                              <span className="button-space">
                                                Remove
                                              </span>
                                            </GenericButton>
                                          </div>
                                          {/*)} */}
                                        </div>
                                      ) : userSelectedEnrollmentFlow ===
                                        'DeleteDependent' ? (
                                        <div>
                                          <GenericButton
                                            variant="secondary"
                                            className="btn-remove"
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleExistingDependentRemove(
                                                item,
                                              );
                                            }}
                                          >
                                            <span>
                                              <EnrollMinusIcon className="remove-icon" />
                                            </span>
                                            <span className="button-space">
                                              Remove
                                            </span>
                                          </GenericButton>
                                        </div>
                                      ) : (
                                        <div className="my-profile-status">
                                          <div>Status</div>
                                          <div className="font-weight-bold">
                                            {item.Status || noValue}
                                          </div>
                                        </div>
                                      )}
                                    </div>
                                  ) : item.DependentNewlyAdded ? (
                                    <div className="enrollment-dependent-btn-container">
                                      <div className="newly-added-btn-container">
                                        <div className="newly-added-label newly-added-label-no-margin">
                                          Newly Added
                                        </div>
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="my-profile-status">
                                      <div>Status</div>
                                      <div className="font-weight-bold">
                                        {item.Status || noValue}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            </Accordion.Toggle>
                            <Accordion.Collapse
                              eventKey={item.DepSequenceNumber}
                            >
                              <Card.Body className="bg-white px-4 py-2">
                                {(!item.dependentsInfoLoaded ||
                                  item.DepSequenceNumber ===
                                    enrollmentFormData.updatedCurrentDependentNumber ||
                                  item.DepSequenceNumber !==
                                    activeDependentSequenceId) &&
                                !item.DependentNewlyAdded &&
                                !item.isDependentUpdated ? (
                                  <Skeleton />
                                ) : !item.dependentsAPIError ? (
                                  <>
                                    <div className="pt-2 dependent-details-container">
                                      <div className="first-column">
                                        {Suppress_Setting?.memberId !==
                                          'hide' && (
                                          <div>
                                            <label>
                                              {CertificateNumberLabel}
                                            </label>
                                            <span className="plain-text ">
                                              {maskedOther(
                                                Suppress_Setting?.memberId
                                                  ? Suppress_Setting?.memberId
                                                  : false,
                                                item.DependentsInformation
                                                  .CertificateNumber,
                                              ) || noValue}
                                            </span>
                                          </div>
                                        )}

                                        <div>
                                          <label>
                                            {t(
                                              'member.pages.my_profile.labels.dob',
                                            )}
                                          </label>
                                          <span className="plain-text ">
                                            {
                                              !item.DependentsInformation
                                                .BirthDate
                                                ? noValue
                                                : formatDate(
                                                    item.DependentsInformation
                                                      .BirthDate,
                                                  )
                                              //moment( item.BirthDate ).format( 'DD-MMM-YYYY' )
                                            }
                                          </span>
                                        </div>

                                        <div>
                                          <label>
                                            {t(
                                              'member.pages.my_profile.labels.gender',
                                            )}
                                          </label>
                                          <span className="plain-text ">
                                            {item.DependentsInformation
                                              .Gender || noValue}
                                          </span>
                                        </div>

                                        <div>
                                          <label>
                                            {t(
                                              'member.pages.my_profile.labels.race',
                                            )}
                                          </label>
                                          <span className="plain-text ">
                                            {item.DependentsInformation.Race ||
                                              noValue}
                                          </span>
                                        </div>

                                        {/*<div>
                              <label>{t('member.pages.my_profile.labels.marital_status')}</label>
                              <span className="plain-text ">{item.DependentsInformation.MaritalStatus || noValue}</span>
                          </div> */}
                                      </div>
                                      <div className="second-column">
                                        {/*{'Employee' == loggedInMemberType &&
                                  <div>
                                  <label>{t('member.pages.my_profile.labels.no_of_dependents')}</label>
                                  <span className="plain-text ">{item.NumberOfDependents || noValue}</span>
                                  </div>
                              } */}

                                        <div>
                                          <label>
                                            {t(
                                              'member.pages.my_profile.labels.age',
                                            )}
                                          </label>
                                          <span className="plain-text ">
                                            {item.DependentsInformation.Age +
                                              ' years' || noValue}
                                          </span>
                                        </div>

                                        {Suppress_Setting?.SSN !== 'hide' &&
                                          item.DependentsInformation
                                            .SocialSecurityNumber && (
                                            <div>
                                              <label>
                                                {t(
                                                  'member.pages.my_profile.labels.ssn',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {maskedSSN(
                                                  Suppress_Setting?.SSN
                                                    ? Suppress_Setting?.SSN
                                                    : false,
                                                  item.DependentsInformation
                                                    .SocialSecurityNumber,
                                                )}
                                              </span>
                                            </div>
                                          )}

                                        {Suppress_Setting?.altId1 !==
                                          'hide' && (
                                          <div>
                                            <label>{AlternateID1Label}</label>
                                            <span className="plain-text ">
                                              {maskedOther(
                                                Suppress_Setting?.altId1
                                                  ? Suppress_Setting?.altId1
                                                  : false,
                                                item.DependentsInformation
                                                  .AlternateID1,
                                              ) || noValue}
                                            </span>
                                          </div>
                                        )}

                                        {Suppress_Setting?.altId2 !==
                                          'hide' && (
                                          <div>
                                            <label>{AlternateID2Label}</label>
                                            <span className="plain-text ">
                                              {maskedOther(
                                                Suppress_Setting?.altId2
                                                  ? Suppress_Setting?.altId2
                                                  : false,
                                                item.DependentsInformation
                                                  .AlternateID2,
                                              ) || noValue}
                                            </span>
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                    <div className="pt-2">
                                      <div className="contact-info-section">
                                        <div className="top-header-container">
                                          <div className="title">
                                            {t(
                                              'member.pages.my_profile.labels.contact_information',
                                            )}
                                          </div>
                                          {!item.DependentNewlyAdded &&
                                            userSelectedEnrollmentFlow ===
                                              'AddressChange' && (
                                              <div>
                                                <GenericButton
                                                  variant="secondary"
                                                  className="btn-update-contact-info"
                                                  onClick={() => {
                                                    updateDependentsContactInfo(
                                                      depResidenceAddress,
                                                      depMailingAddress,
                                                      item.DependentsInformation,
                                                      item,
                                                    );
                                                  }}
                                                >
                                                  <EditIcon
                                                    fillColor={
                                                      themeValuesObject[
                                                        'Secondary-1'
                                                      ] || '#1d90ba'
                                                    }
                                                  />{' '}
                                                  UPDATE
                                                </GenericButton>
                                              </div>
                                            )}
                                        </div>
                                        <div className="pt-2 dependent-details-container">
                                          <div className="first-column">
                                            <div>
                                              <label>
                                                {t(
                                                  'member.common_labels.email',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.PhoneEmailInfo?.Email1 ||
                                                  noValue}
                                              </span>
                                            </div>
                                            <div>
                                              <label>
                                                {t(
                                                  'member.common_labels.alternate_email',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.PhoneEmailInfo?.Email2 ||
                                                  noValue}
                                              </span>
                                            </div>
                                            <div>
                                              <label>
                                                {t(
                                                  'member.pages.my_profile.labels.home_phone',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.PhoneEmailInfo?.HomePhone
                                                  ? item.PhoneEmailInfo?.HomePhone.replace(
                                                      /\D/g,
                                                      '',
                                                    ).substring(0, 10) &&
                                                    `+1 (${item.PhoneEmailInfo?.HomePhone.substring(
                                                      0,
                                                      3,
                                                    )}) ${item.PhoneEmailInfo?.HomePhone.substring(
                                                      3,
                                                      6,
                                                    )} ${item.PhoneEmailInfo?.HomePhone.substring(
                                                      6,
                                                      10,
                                                    )}`
                                                  : noValue}
                                              </span>
                                            </div>
                                            <div>
                                              <label>
                                                {t(
                                                  'member.pages.my_profile.labels.work_phone',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.PhoneEmailInfo?.WorkPhone
                                                  ? item.PhoneEmailInfo?.WorkPhone.replace(
                                                      /\D/g,
                                                      '',
                                                    ).substring(0, 10) &&
                                                    `+1 (${item.PhoneEmailInfo?.WorkPhone.substring(
                                                      0,
                                                      3,
                                                    )}) ${item.PhoneEmailInfo?.WorkPhone.substring(
                                                      3,
                                                      6,
                                                    )} ${item.PhoneEmailInfo?.WorkPhone.substring(
                                                      6,
                                                      10,
                                                    )}`
                                                  : noValue}
                                              </span>
                                            </div>
                                            <div>
                                              <label>
                                                {t(
                                                  'member.pages.my_profile.labels.mobile_phone',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.PhoneEmailInfo
                                                  ?.MobilePhone
                                                  ? item.PhoneEmailInfo?.MobilePhone.replace(
                                                      /\D/g,
                                                      '',
                                                    ).substring(0, 10) &&
                                                    `+1 (${item.PhoneEmailInfo?.MobilePhone.substring(
                                                      0,
                                                      3,
                                                    )}) ${item.PhoneEmailInfo?.MobilePhone.substring(
                                                      3,
                                                      6,
                                                    )} ${item.PhoneEmailInfo?.MobilePhone.substring(
                                                      6,
                                                      10,
                                                    )}`
                                                  : noValue}
                                              </span>
                                            </div>
                                          </div>

                                          <div className="second-column">
                                            <div>
                                              <label>
                                                {t(
                                                  'member.common_labels.residential_address',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.isDependentUpdated
                                                  ? getAddressLine(
                                                      item.DependentResidentailAddress,
                                                    ).trim()
                                                  : item.DependentResidentailAddress.trim() ||
                                                    noValue}
                                                <br />
                                                {item.isDependentUpdated
                                                  ? getAddressLineZip(
                                                      item.DependentResidentailAddressZip,
                                                    ).trim() || ''
                                                  : item.DependentResidentailAddressZip.trim() ||
                                                    ''}
                                              </span>
                                            </div>
                                            <div>
                                              <label>
                                                {t(
                                                  'member.common_labels.mailing_address',
                                                )}
                                              </label>
                                              <span className="plain-text ">
                                                {item.isDependentUpdated
                                                  ? getAddressLine(
                                                      item.DependentMailingAddress,
                                                    ).trim()
                                                  : item.DependentMailingAddress.trim() ||
                                                    noValue}
                                                <br />
                                                {item.isDependentUpdated
                                                  ? getAddressLineZip(
                                                      item.DependentMailingAddressZip,
                                                    ).trim() || ''
                                                  : item.DependentMailingAddressZip.trim() ||
                                                    ''}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <CustomClientError
                                    ErrorHeading="Something went wrong with request!"
                                    ErrorMessage="Please try again."
                                  />
                                )}
                              </Card.Body>
                            </Accordion.Collapse>
                          </div>
                        ))}
                      <div className="padLR-24">
                        <GenericMessage
                          wrapperClasses="mt-4 mb-4"
                          message="Disclaimer Example: Adding a dependent does not automatically enroll them in coverage. After entering your new dependent information you will then have the opportunity to add your dependent to your coverage."
                          messageType={'warning'}
                          showMessage={true}
                          hideCloseButton={true}
                        />
                      </div>
                    </div>
                  </Accordion>
                ) : (
                  <CustomClientError
                    ErrorHeading="This Member does not have any Dependent(s)."
                    ErrorMessage="To add a Dependent, contact your Administrator."
                  />
                )}
                <div className="ml4 mr-4 pb-4">
                  <Row>
                    <Col className="d-flex justify-content-end">
                      <GenericButton
                        variant="link"
                        onClick={() => {
                          setEnrollmentFormData({
                            ...enrollmentFormData,
                            newlyAddedDependent: [],
                          });
                          prevStep();
                        }}
                        className="form-btn"
                      >
                        Back
                      </GenericButton>
                      <GenericButton
                        type="button"
                        className="mr-0"
                        disable={handleValidation()}
                        buttonDisabled={handleValidation}
                        onClick={() => onContinueHandler()}
                      >
                        Continue
                      </GenericButton>
                    </Col>
                  </Row>
                </div>
              </div>
            </Col>
          </Row>
        )}
      {showEditDependentsContactDetails && !showAddDependents && (
        <EditDependentInfo
          enrollmentFormData={enrollmentFormData}
          setEnrollmentFormData={setEnrollmentFormData}
          nextStep={nextStep}
          prevStep={prevStep}
          setShowEditDependentsContactDetails={
            setShowEditDependentsContactDetails
          }
          editDependentsContactItem={editDependentsContactItem}
          activeDependentId={activeDependentId}
          dependentInformation={true}
        />
      )}
      {showAddDependents && !showEditDependentsContactDetails && (
        <AddDependentInfo
          //nextStep={nextStep}
          prevStep={prevStep}
          //setAddDepenedentInfoStep={setAddDepenedentInfoStep}
          //setCurrentStep={setCurrentStep}
          enrollmentFormData={enrollmentFormData}
          setEnrollmentFormData={setEnrollmentFormData}
          setShowAddDependents={setShowAddDependents}
          dependentsData={dependentsData}
        />
      )}
      {!enrollmentFormData?.isDependentInfoAvailable && (
        <DepSkeleton count={8} height={25} />
      )}
    </div>
  );
};

export default DependentInfo;
